/* WITHOUTSTANDING flagship — theme behaviour.
   Enhancement only: content, links, price and purchase remain real HTML
   without JS (product form falls back to a normal POST to /cart/add). */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- header ---------- */
  var header = document.querySelector('.fl-header');
  var heroEl = document.querySelector('.hero');
  function setHeader() {
    if (!header) return;
    if (getComputedStyle(header).position === 'sticky') { header.classList.add('solid'); return; }
    var threshold = heroEl ? heroEl.offsetHeight - 80 : 10;
    header.classList.toggle('solid', window.scrollY > (heroEl ? threshold : 10));
  }
  window.addEventListener('scroll', setHeader, { passive: true });
  setHeader();

  var menuBtn = document.querySelector('.menu-btn');
  var nav = document.querySelector('.main-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
      if (open) header.classList.add('solid'); else setHeader();
    });
  }

  /* mobile uses the art-directed still — never download the desktop film */
  /* Desktop film: built only here, only >=701px, only at idle. The server
     sends no video element at all, so the mobile path stays photo-only. */
  var heroSlot = document.querySelector('[data-hero-video]');
  var isTouchDevice = window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
  if (heroSlot && window.matchMedia('(min-width: 701px)').matches && !isTouchDevice && !reduceMotion.matches) {
    var buildHeroFilm = function () {
      var v = document.createElement('video');
      v.className = 'autoplay-video hero-video-desktop';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1;
      v.preload = 'auto';
      var s = document.createElement('source');
      s.src = heroSlot.getAttribute('data-hero-video'); s.type = 'video/mp4';
      v.appendChild(s);
      heroSlot.parentNode.replaceChild(v, heroSlot);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting) { var q = e.target.play(); if (q && q.catch) q.catch(function () {}); }
            else e.target.pause();
          });
        }, { threshold: 0.15 }).observe(v);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(buildHeroFilm, { timeout: 3000 });
    else setTimeout(buildHeroFilm, 1500);
  }

  /* ---------- homepage mobile sticky access ---------- */
  var homeSticky = document.querySelector('.home-sticky');
  if (homeSticky && heroEl) {
    var footerEl = document.querySelector('.site-footer');
    var chooseEl = document.querySelector('.choose');
    var nearEnd = false;
    if ('IntersectionObserver' in window && footerEl) {
      var fio = new IntersectionObserver(function (en) {
        nearEnd = en.some(function (e) { return e.isIntersecting; });
        setHomeSticky();
      }, { rootMargin: '120px' });
      fio.observe(footerEl);
      if (chooseEl) fio.observe(chooseEl);
    }
    function setHomeSticky() {
      var past = window.scrollY > heroEl.offsetHeight - 40;
      homeSticky.classList.toggle('show', past && !nearEnd);
    }
    window.addEventListener('scroll', setHomeSticky, { passive: true });
    setHomeSticky();
  }

  /* ---------- deferred images: bytes only on approach ---------- */
  var hydrateImg = function (im) {
    if (!im || !im.dataset || !im.dataset.src) return;
    if (im.dataset.sizes) im.sizes = im.dataset.sizes;
    if (im.dataset.srcset) im.srcset = im.dataset.srcset;
    im.src = im.dataset.src;
    delete im.dataset.src;
  };

  /* Download throttle: never start more than two below-fold images at once.
     Whichever image sits highest in the document goes first, so the first image
     you meet in a section is always the one being fetched, and a section with
     four details no longer fires all four in the same moment. */
  var MAX_IMG_CONCURRENCY = 2;
  var imgInflight = 0;
  var imgQueue = [];
  var pumpImages = function () {
    while (imgInflight < MAX_IMG_CONCURRENCY && imgQueue.length) {
      imgQueue.sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
      });
      var im = imgQueue.shift();
      if (!im || !im.dataset || !im.dataset.src) continue;
      /* The image nearest the top — the first one you meet in a section — gets the
         high hint; anything sharing the pipe with it yields. */
      try { im.fetchPriority = (imgInflight === 0) ? 'high' : 'low'; } catch (e) {}
      imgInflight++;
      var release = function () { imgInflight--; pumpImages(); };
      im.addEventListener('load', release, { once: true });
      im.addEventListener('error', release, { once: true });
      hydrateImg(im);
    }
  };
  var queueImg = function (im) {
    if (!im || !im.dataset || !im.dataset.src) return;
    if (imgQueue.indexOf(im) === -1) imgQueue.push(im);
    pumpImages();
  };
  (function () {
    var deferred = Array.prototype.slice.call(document.querySelectorAll('img[data-src]')).filter(function (im) {
      return !im.closest('[data-track]') && !im.closest('.positions-media');
    });
    if (!deferred.length) return;
    /* Attach the observer only AFTER the hero has painted, so below-fold media never
       competes with the LCP image for bandwidth. Once armed, a generous rootMargin
       loads each image roughly 1.5 viewports before it is reached, so normal
       scrolling does not expose blank media. */
    var arm = function () {
      if ('IntersectionObserver' in window) {
        var lio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { queueImg(e.target); lio.unobserve(e.target); }
          });
        }, { rootMargin: '1500px 0px' });
        deferred.forEach(function (im) { lio.observe(im); });
      } else deferred.forEach(hydrateImg);
    };
    var start = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(arm, { timeout: 1200 });
      else setTimeout(arm, 200);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  })();

  /* ---------- reveal grammar ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- autoplay video management ---------- */
  var vids = document.querySelectorAll('video[data-autoplay]');
  if (vids.length) {
    var play = function (v) {
      if (reduceMotion.matches) return;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    /* Video bytes only after the browser is idle: stills and text win first. */
    var attachPoster = function (v) {
      if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; }
    };
    var armVideos = function () {
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { attachPoster(e.target); play(e.target); } else e.target.pause();
          });
        }, { threshold: 0.15 });
        vids.forEach(function (v) { vio.observe(v); });
      } else vids.forEach(function (v) { attachPoster(v); play(v); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(armVideos, { timeout: 2500 });
    else setTimeout(armVideos, 1200);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
    if (reduceMotion.matches) vids.forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
    document.querySelectorAll('.vid-pause').forEach(function (btn) {
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      btn.addEventListener('click', function () {
        if (v.paused) { v.play().catch(function () {}); btn.textContent = '❚❚'; btn.setAttribute('aria-label', 'Pause video'); }
        else { v.pause(); btn.textContent = '►'; btn.setAttribute('aria-label', 'Play video'); }
      });
    });
  }

  /* ---------- four positions selector ---------- */
  var positions = document.querySelector('[data-positions]');
  if (positions) {
    var items = Array.prototype.slice.call(positions.querySelectorAll('.position-item'));
    var imgs = Array.prototype.slice.call(positions.querySelectorAll('.positions-media img'));
    var curP = 0, posSeen = false;
    var posMedia = positions.querySelector('.positions-media');
    if (posMedia && 'IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (en) {
        if (en.some(function (e) { return e.isIntersecting; })) {
          posSeen = true; hydrateImg(imgs[curP]); pio.disconnect();
        }
      }, { rootMargin: '1200px 0px' });
      if (document.readyState === 'complete') pio.observe(posMedia);
      else window.addEventListener('load', function () { pio.observe(posMedia); }, { once: true });
    } else { posSeen = true; hydrateImg(imgs[0]); }
    var triggers = items.map(function (it) { return it.querySelector('.position-trigger'); });
    var activateP = function (i, focus) {
      items.forEach(function (it, j) {
        var on = i === j;
        it.classList.toggle('active', on);
        triggers[j].setAttribute('aria-expanded', String(on));
      });
      curP = i;
      imgs.forEach(function (im, j) {
        im.classList.toggle('active', i === j);
        if (i === j && posSeen) hydrateImg(im);
      });
      if (focus) triggers[i].focus();
    };
    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { activateP(i); });
      t.addEventListener('keydown', function (ev) {
        var n = null;
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') n = (i + 1) % triggers.length;
        if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') n = (i - 1 + triggers.length) % triggers.length;
        if (ev.key === 'Home') n = 0;
        if (ev.key === 'End') n = triggers.length - 1;
        if (n !== null) { ev.preventDefault(); activateP(n, true); }
      });
    });
    activateP(0);
  }

  /* ---------- positions: size select → single Add to bag ---------- */
  document.querySelectorAll('[data-pos-buy]').forEach(function (buy) {
    var addBtn = buy.querySelector('[data-pos-add]');
    var sizes = Array.prototype.slice.call(buy.querySelectorAll('[data-pos-size]'));
    var chosen = null;
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = b;
        sizes.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('selected', on);
          x.setAttribute('aria-pressed', String(on));
        });
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bag — ' + b.dataset.size;
      });
    });
    addBtn.addEventListener('click', function () {
      if (!chosen) return;
      addVariant(chosen.dataset.posSize, buy.dataset.statement + ', size ' + chosen.dataset.size);
    });
  });

  /* ---------- PDP carousel: one frame, dots, discreet desktop arrows ---------- */
  var carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    var track = carousel.querySelector('[data-track]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-dot]'));
    var slideW = function () { var s = track.querySelector('[data-slide]'); return s ? s.getBoundingClientRect().width : track.clientWidth; };
    var index = function () { var w = slideW(); return w ? Math.round(track.scrollLeft / w) : 0; };
    /* A direct dot-jump must not hydrate the slides the smooth scroll passes:
       while a far jump is in flight, path hydration is suppressed until the
       target lands. Any real touch/wheel input cancels the suppression. */
    var jumpTarget = null;
    var sync = function () {
      var i = index();
      if (jumpTarget === null) hydrateAround(i);
      else if (i === jumpTarget) { jumpTarget = null; hydrateAround(i); }
      dots.forEach(function (d, n) {
        var on = n === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', String(on));
      });
    };
    var go = function (i) {
      if (Math.abs(i - index()) > 1) jumpTarget = i;
      hydrateAround(i);
      track.scrollTo({ left: i * slideW(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { jumpTarget = null; }, { passive: true });
    });
    /* progressive gallery loader: only current, previous and next slides carry real URLs */
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var hydrate = function (i) {
      var s = slides[i]; if (!s) return;
      var im = s.querySelector('img[data-src]');
      if (!im) return;
      im.sizes = im.getAttribute('data-sizes') || '100vw';
      im.srcset = im.getAttribute('data-srcset') || '';
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
    };
    var hydrateAround = function (i) { hydrate(i); hydrate(i + 1); hydrate(i - 1); };
    hydrateAround(0);
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); }); });
    var prev = carousel.querySelector('[data-prev]');
    var next = carousel.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, index() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(dots.length - 1, index() + 1)); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(dots.length - 1, index() + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, index() - 1)); }
    });
  }

  var buyForm = document.querySelector('[data-buy-form]');
  var stickyBuy = document.querySelector('.sticky-buy');
  if (buyForm && stickyBuy && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      stickyBuy.classList.toggle('show', !visible);
      if (visible) stickyBuy.setAttribute('inert', ''); else stickyBuy.removeAttribute('inert');
    }, { rootMargin: '-70px 0px 0px 0px' });
    sio.observe(buyForm);
    var sbBtn = stickyBuy.querySelector('[data-sticky-add]');
    if (sbBtn) sbBtn.addEventListener('click', function () {
      var evt;
      try { evt = new Event('submit', { cancelable: true, bubbles: true }); }
      catch (e) { evt = document.createEvent('Event'); evt.initEvent('submit', true, true); }
      buyForm.dispatchEvent(evt);
    });
  }

  /* ---------- Shopify cart drawer ---------- */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');
  var closeBtn = document.querySelector('.cart-close');
  var itemsEl = document.querySelector('.cart-items');
  var countEls = document.querySelectorAll('.cart-count');
  var totalEl = document.querySelector('[data-cart-total]');
  var live = document.getElementById('cart-live');
  var lastFocus = null;

  function announce(msg) {
    if (live) { live.textContent = ''; requestAnimationFrame(function () { live.textContent = msg; }); }
  }
  function money(cents) {
    return '£' + (cents % 100 === 0 ? (cents / 100) : (cents / 100).toFixed(2));
  }
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.<br>Four statements are waiting.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
      var name = (i.product_title || '').replace('DROP 001 — ', '');
      return '<div class="cart-item">' +
        (img ? '<img src="' + img + '" alt="" width="76" height="100">' : '<span></span>') +
        '<div><p class="ci-name">' + name + '</p>' +
        '<p class="ci-meta">Size ' + i.variant_title + ' · Seedpearl</p>' +
        '<div class="ci-qty" role="group" aria-label="Quantity for ' + name + ' size ' + i.variant_title + '">' +
        '<button type="button" data-line-change="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span aria-live="polite">' + i.quantity + '</span>' +
        '<button type="button" data-line-change="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div style="display:grid;gap:10px;justify-items:end"><span class="ci-price">' + money(i.final_line_price) + '</span>' +
        '<button type="button" class="ci-remove" data-line-change="' + i.key + '" data-q="0">Remove</button></div></div>';
    }).join('');
  }
  function refreshCart() { return fetchCart().then(renderCart).catch(function () {}); }

  function openCart() {
    if (!drawer) return;
    document.body.classList.add('cart-open');
    lastFocus = document.activeElement;
    drawer.classList.add('open'); overlay.classList.add('open');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    (closeBtn || drawer).focus();
  }
  function closeCart() {
    if (!drawer) return;
    document.body.classList.remove('cart-open');
    drawer.classList.remove('open'); overlay.classList.remove('open');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart();
  });
  if (drawer) {
    drawer.setAttribute('inert', '');
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-line-change]');
      if (!t) return;
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.dataset.lineChange, quantity: +t.dataset.q })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        if (+t.dataset.q === 0) announce('Item removed from cart');
      }).catch(function () {});
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('button, a[href], input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  var addInFlight = false;
  function addVariant(variantId, label) {
    if (addInFlight) return Promise.resolve();
    addInFlight = true;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: +variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshCart();
    }).then(function () {
      announce((label || 'Item') + ' added to cart');
      openCart();
      addInFlight = false;
    }).catch(function () { addInFlight = false; announce('Could not add to cart — please try again'); });
  }

  /* PDP form: intercept submit for drawer add (falls back to normal POST without JS) */
  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      var size = buyForm.querySelector('input[name="id"]:checked');
      if (!size) { e.preventDefault(); announce('Choose a size first'); var sf = buyForm.querySelector('.size-field'); if (sf) sf.scrollIntoView({ block: 'center' }); return; }
      e.preventDefault();
      addVariant(size.value, buyForm.dataset.name + ', size ' + (size.dataset.title || ''));
    });
  }
  /* quick add buttons carry a variant id */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      addVariant(btn.dataset.quickAdd, btn.dataset.name);
    });
  });

  refreshCart();


  window.__wsReady = performance.now();
})();
